<template>
    <div>
        <div v-show="showLeftBar">
            <el-tabs v-model="activeName" type="card" v-if="fileType === 'text' || fileType === 'docx'">
                <el-tab-pane label="内容域操作" name="first">
                    <ctctrl v-bind:docEditor="docEditor"
                            v-bind:config="config"
                            v-bind:ctctrlTree="ctctrlTree"
                            v-bind:ctctrlContentAll="ctctrlContentAll"
                    ></ctctrl>
                </el-tab-pane>
                <el-tab-pane label="其他" name="second">
                    <other-application v-bind:docEditor="docEditor"
                                       v-bind:extractedText="extractedText"
                                       v-bind:outjson="outjson"
                                       v-bind:extractedRevision="extractedRevision"
                                       v-bind:extractedComment="extractedComment"
                                       v-bind:config="config"
                                       @water="resetConfig"
                    ></other-application>
                </el-tab-pane>
            </el-tabs>
            <div v-else-if="fileType === 'spreadsheet' || fileType === 'xlsx'">
                <excel-bar v-bind:docEditor="docEditor"
                           v-bind:config="config"
                           v-bind:extractedCellContent="extractedCellContent"
                           v-bind:extractedCellContentAll="extractedCellContentAll"
                ></excel-bar>
            </div>
            <div v-else>
                <ppt-bar v-bind:docEditor="docEditor"
                         v-bind:extractedText="extractedText"
                         v-bind:config="config"
                ></ppt-bar>
            </div>
        </div>

    </div>
</template>

<script>
    import "@/assets/css/home.css";
    import Ctctrl from "../components/wordbar";
    import OtherApplication from "../components/otherApplication";
    // import SpreadSheet from "../components/excelBar";
    import ExcelBar from "../components/excelBar";
    import PptBar from "../components/pptBar";

    export default {
        name: "leftBar",
        components: {PptBar, ExcelBar, OtherApplication, Ctctrl},
        props: ['docEditor', 'config', 'ctctrlTree', 'ctctrlContentAll', 'extractedText','extractedRevision','outjson', 'extractedComment','fileType', 'extractedCellContent', 'extractedCellContentAll'],
        data: function() {
            return {
                activeName: 'first',
                showLeftBar: true,
            }
        },
        methods: {
            resetConfig(config){
                console.log('回传的参数:', config);
              
                this.$emit('waterf', config);
            }
        },
        created() {
            // this.fileType = localStorage.getItem('fileType')
            // log(">>>>>type in left bar:", this.fileType)
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/leftBar.vue